import "./HotelSEODigitalMarketingServices.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Strategy from "./sections/Strategy";
import Results from "./sections/Results";
import Footer from "@/reusable_sections/Footer";
export default function HotelSEODigitalMarketingServicesPage() {
  return <div>
      <Header />
      <Hero />
      <Strategy />
      <Results />
      <Footer />
    </div>;
}